























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Resolve } from 'vue-di';
import EnrollmentModule from '~/store/enrollment';
import EligibilityModule from '~/store/eligibility';
import SessionModule from '~/store/session';

@Component<DefaultError>({})
export default class DefaultError extends Vue {
    @Resolve
    enrollment!: EnrollmentModule;
    @Resolve
    eligibility!: EligibilityModule;
    @Resolve
    session!: SessionModule;

    @Prop({ type: [Number, String], required: false })
    public code!: string;

    @Prop({ type: Object, required: false })
    public details!: { icon: [string, string]; title: string; message: string; statusCode: number };

    public get statusCode() {
        return this.code || this.errorPage.statusCode;
    }

    public get errorPage() {
        return this.details || this.$settings.errorPages[this.code] || this.$settings.errorPages.default;
    }

    public get title() {
        return this.errorPage.title;
    }

    public get icon() {
        return this.errorPage.icon;
    }

    public get message() {
        return this.errorPage.message;
    }

    mounted() {
        this.enrollment.clear();
        this.eligibility.clear();
        this.session.logout({
            localOnly: true,
        });
    }
}
